import _ from 'lodash';
import Validator from 'validatorjs';
import React, { Component } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { FormControl } from '../../../../../facturotopia';
import CartaPorteAutotransporteSegurosForm from './CartaPorteAutotransporteSegurosForm';
import CartaPorteCatalogoManager from '../../../../catalogs/managers/CartaPorteCatalogoManager';
import CartaPorteAutotransporteRemolquesManager from './CartaPorteAutotransporteRemolquesManager';
import CartaPorteAutotransporteIdentificacionVehicularForm from './CartaPorteAutotransporteIdentificacionVehicularForm';
import CartaPorteClienteManager from '../../../../catalogs/managers/CartaPorteClienteManager';

class CartaPorteAutotransporteForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    const { data = {} } = props;
    const { Mercancias = {} } = data;
    const { Autotransporte = {} } = Mercancias;

    this.state = {
      data: {
        ...Autotransporte,
      },
      isValid: false,
      isTouchedForm: false,
      isValidSeguros: false,
      isValidIdentificacionVehicular: false,
      validator: new Validator({}, this.rules({})),
    };
  }

  componentDidMount() {
    const TipoPermiso = CartaPorteCatalogoManager.get('c_cp_tipo_permiso');

    const { autotransporte } = CartaPorteClienteManager.get('carta-porte');

    let catalogos = {};

    catalogos.TipoPermiso = this.getCatalogo(TipoPermiso);
    catalogos.ClienteAutotransporte = this.getSortedCatalogoCliente(autotransporte, 'placa_vehiculo', 'placa_vehiculo');

    this.setState({
        catalogos
      });
  }

  rules(data) {
    return {
      'PermSCT': ['required', 'string'],
      'NumPermisoSCT': ['required', 'string', 'min:1', 'max:50'],
      'IdentificacionVehicular.ConfigVehicular': ['required', 'string'],
      'IdentificacionVehicular.PlacaVM': ['required', 'string', 'regex:/^[^(?!.*s)-]{5,7}$/'],
      'IdentificacionVehicular.AnioModeloVM': ['required', 'integer', 'regex:/^(19[0-9]{2}|20[0-9]{2})$/'],
      'Seguros.AseguraRespCivil': ['required', 'string', 'min:3', 'max:50'],
      'Seguros.PolizaRespCivil': ['required', 'string', 'min:3', 'max:30'],
    }
  }

  getCatalogo = (values) => {
    if (!!values) {
      const sorted = _.sortBy(values.map((item) => {
        return {
          label: item.descripcion,
          value: item.clave
        }
      }), 'label');

      return [
        {
          label: 'Selecciona',
          value: ''
        }
      ].concat(sorted);
    }
  }

  getSortedCatalogoCliente = (values, label, id) => {
    if (!values) {
      return [];
    }

    return _.sortBy(values.map((item) => {
      return {
        label: `Placa: ${item[label]}`,
        value: item[id],
        permiso_sct: item.permiso_sct,
        numero_de_permiso_sct: item.numero_de_permiso_sct,
        nombre_de_la_aseguradora: item.nombre_de_la_aseguradora,
        numero_de_poliza_de_seguro: item.numero_de_poliza_de_seguro,
        aseguradora_medio_ambiente: item.aseguradora_medio_ambiente,
        poliza_aseguradora_medio_ambiente: item.poliza_aseguradora_medio_ambiente,
        aseguradora_de_carga: item.aseguradora_de_carga,
        poliza_aseguradora_de_carga: item.poliza_aseguradora_de_carga,
        prima_seguro: item.prima_seguro,
        clave_vehicular: item.clave_vehicular,
        configuracion_vehicular: item.configuracion_vehicular,
        placa_vehiculo: item.placa_vehiculo,
        ano_modelo: item.ano_modelo,

      }
    }), 'placa_vehiculo');
  }

  handleOnAutotransporteChange = (value) => {
    let data = {
      ...this.state.data,
      ...value,
    }

    if (!_.isEmpty(value)) {
      data = {
          ...this.state.data,
          ClienteAutotransporte: value.placa_vehiculo.toString(),
          PermSCT: value.permiso_sct.toString(),
          NumPermisoSCT: value.numero_de_permiso_sct.toString(),
          IdentificacionVehicular: {
            AnioModeloVM: value.ano_modelo.toString(),
            ConfigVehicular: value.clave_vehicular.toString(),
            PlacaVM: value.placa_vehiculo.toString(),
          },
          Seguros: {
            AseguraRespCivil: value.nombre_de_la_aseguradora.toString(),
            PolizaRespCivil: value.numero_de_poliza_de_seguro.toString(),
            AseguraMedAmbiente: value.aseguradora_medio_ambiente.toString(),
            PolizaMedAmbiente: value.poliza_aseguradora_medio_ambiente.toString(),
            AseguraCarga: value.aseguradora_de_carga.toString(),
            PolizaCarga: value.poliza_aseguradora_de_carga.toString(),
            PrimaSeguro: value.prima_seguro.toString(),
          }
      };
    }

    this.handleOnChange(data);
  }

  handleOnChange = (value) => {
    const data = {
      ...this.state.data,
      ...value
    }

    const validator = this.validate(data);
    const isValid = validator.passes();
    const mercancias = this.props.data.Mercancias || {};
    const event = {
      isValid: isValid,
      name: 'autotransporte'
    }

    this.props.onAdd({
      ...this.props.data,
      Mercancias: {
        ...mercancias,
        Autotransporte: data
      }
    }, event);

    this.setState({
      data,
      isTouchedForm: true,
      isValid: isValid
    });
  }

  validate(data) {
    const validator = new Validator(data, this.rules(data));

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnAdditionalCheckboxChange = (event) => {
    const { name, checked } = event.target;

    this.setState({
      [name]: checked
    });
  }

  handleOnAdditionalChange = (additional) => {
    const data = {
      ...this.state.data,
      ...additional
    }

    this.handleOnChange(data);
  }

  handleOnIdentificacionVehicularDataChange = (event) => {
    const identificacionVehicular = {
      ...this.state.data.IdentificacionVehicular,
      ...event.data
    }

    const data ={
      ...this.state.data,
      IdentificacionVehicular: identificacionVehicular
    }

    this.handleOnChange(data);
  }

  handleOnSegurosDataChange = (event) => {
    const seguros = {
      ...this.state.data.Seguros,
      ...event.data
    }

    const data = {
      ...this.state.data,
      Seguros: seguros
    }

    this.handleOnChange(data);
  }

  handleOnRefreshData = () => {
    this.setState({
      isTouchedForm: false,
      remolquesChecked: false,
      data: {}
    })
  }

  render() {
    const {
      data = {},
      catalogos = {},
      remolquesChecked,
    } = this.state;

    const rules = this.rules(data);

    const { Version } = this.props.data;

    return (
      <div className="pb-4">
        <div>
          <strong className="text-black text-upper">Autotransporte</strong>
        </div>

        <div className="section pt-2">

        <Row className="pb-2">
          <Col sm md={ 11 }>
            <FormControl type="ahead"
              label="Catálogo Autotransporte"
              id="ClienteAutotransporte"
              name="ClienteAutotransporte"
              help=""
              value={ data.ClienteAutotransporte }
              placeholder={ data.ClienteAutotransporte }
              options={ catalogos.ClienteAutotransporte }
              onSelect={ this.handleOnAutotransporteChange }
            />
          </Col>

          <Col sm md={ 1 } className="text-right" style={ { marginTop: "28px" } }>
            <Button
              size="lg"
              variant="secondary"
              onClick={ this.handleOnRefreshData }
            >
              <FontAwesomeIcon icon={ ['fas', 'trash'] } />
            </Button>
          </Col>
        </Row>

          <div>
            <strong>Permiso</strong>
          </div>

          <Row>
            <Col sm md={ 4 }>
              <FormControl type="select"
                label="Perm SCT"
                name="PermSCT"
                placeholder=""
                help=""
                rules={ rules.PermSCT }
                value={ data.PermSCT }
                options={ catalogos.TipoPermiso }
                onChange={ this.handleOnChange }
              />
            </Col>

            <Col sm md={ 4 }>
              <FormControl type="text"
                label="Número Permiso SCT"
                name="NumPermisoSCT"
                placeholder=""
                help=""
                minLength="1"
                maxLength="50"
                rules={ rules.NumPermisoSCT }
                value={ data.NumPermisoSCT }
                onChange={ this.handleOnChange }
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <CartaPorteAutotransporteIdentificacionVehicularForm
                data={ data.IdentificacionVehicular || {} }
                version={ Version }
                onFormDataChange={ this.handleOnIdentificacionVehicularDataChange }
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <CartaPorteAutotransporteSegurosForm
                data={ data.Seguros || {} }
                onFormDataChange={ this.handleOnSegurosDataChange }
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <Form.Group controlId="remolquesChecked">
                <Form.Check type="checkbox"
                  name="remolquesChecked"
                  label="Incluir Remolques"
                  checked={ remolquesChecked || false }
                  onChange={ this.handleOnAdditionalCheckboxChange }
                />
              </Form.Group>
            </Col>
          </Row>

          { !!remolquesChecked && (
            <CartaPorteAutotransporteRemolquesManager
              data={ data }
              onChange={ this.handleOnAdditionalChange }
            />
          )}

        </div>
      </div>
    )
  }
}

export default CartaPorteAutotransporteForm;